import { render, staticRenderFns } from "./Negative.vue?vue&type=template&id=0bb93c51&"
import script from "./Negative.vue?vue&type=script&lang=ts&"
export * from "./Negative.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports